<template>
  <div>
    <div class="serial-code-table" v-if="is_table_screen">
      <div class="mb-x2" layout="row" layout-align="space-between-center">
        <div layout>
          <el-button type="primary" @click="createNewSerialCode"><i class="mdi mdi-plus"></i>追加</el-button>
        </div>
        <div class="flex-row">
          <el-dropdown trigger="click" @command="selectAction">
            <el-button type="default"
              ><i class="mdi mdi-playlist-play"></i>一括操作<i class="mdi mdi-chevron-down ml-x2 mr-0"></i
            ></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(option, index) in action.options" :key="index" :command="option.value">{{
                option.label
              }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <csv-download :download="downloadCsv"></csv-download>
        </div>
      </div>
      <div class="flex-row">
        <span layout>ステータス</span>
        <select-form
          class="status-filter"
          :value="options.filter"
          :options="status.options"
          :onChange="status.onChange"
        ></select-form>
        <div class="flex-row" v-if="campaign.type === 'old_web_instantwin'">
          <span layout>割り当てタイミング</span>
          <select-form
            class="assign-timing-filter"
            :value="options.type"
            :options="assignTiming.options"
            :onChange="assignTiming.onChange"
          ></select-form>
        </div>
      </div>
      <el-table
        :data="serialCodeList"
        stripe
        @header-click="headerClick"
        style="width: 100%"
        empty-text="データがありません。"
      >
        <el-table-column
          label="ステータス"
          sort-by="-tw_campaign_message_id"
          :render-header="renderHeader"
          min-width="20%"
        >
          <template slot-scope="scope">
            <div class="text-success" v-if="scope.row.twCampaignApplicantId">
              割り当て済
              <div class="text-sub-color" v-if="scope.row.userIsUsed">使用済み</div>
            </div>
            <div class="text-disabled" v-else>未割り当て</div>
          </template>
        </el-table-column>
        <el-table-column
          label="割り当てタイミング"
          sort-by="type"
          :render-header="renderHeader"
          min-width="20%"
          v-if="campaign.type === 'old_web_instantwin'"
        >
          <template slot-scope="scope"
            ><span>{{ scope.row.type === 0 ? '当選DM' : 'WEBページ' }}</span></template
          >
        </el-table-column>
        <el-table-column label="シリアルコード" sort-by="serial_code" :render-header="renderHeader" min-width="30%">
          <template slot-scope="scope">
            <div v-html="convertSerialCode(scope.row.serialCode)"></div>
          </template>
        </el-table-column>
        <el-table-column label="割り当てアカウント" sort-by="name" :render-header="renderHeader" min-width="25%">
          <template slot-scope="scope">
            <applicant-name
              v-if="scope.row.twCampaignApplicantId"
              :applicant="scope.row.applicant"
              screen="シルアルコード管理"
            ></applicant-name>
            <div v-else layout-align="start">-</div>
          </template>
        </el-table-column>
        <el-table-column min-width="10%">
          <template slot-scope="scope">
            <div layout layout-align="end">
              <el-tooltip placement="top" content="削除">
                <el-button class="el-button--icon" type="default" @click="deleteSerialCode(scope.row.id)"
                  ><i class="mdi mdi-delete-forever"></i
                ></el-button>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="mt-x2" layout layout-align="space-between-center">
        <pagination
          flex="1"
          type="シルアルコード管理"
          :total="options.total"
          :pagingNo="options.pagingNo"
          :limitCount="options.limitCount"
          :onChangePagingNo="onChangePagingNo"
          :onChangeLimitCount="onChangeLimitCount"
        ></pagination>
      </div>
    </div>
    <serial-code-import-reset
      :screen="screen"
      v-if="!is_table_screen"
      :isChangeWithoutSubmit="isChangeWithoutSubmit"
      @update:isChangeWithoutSubmit="$emit('update:isChangeWithoutSubmit', $event)"
      @back="selectAction()"
    ></serial-code-import-reset>
  </div>
</template>

<style lang="scss">
@use '@/client/assets/scss/variables.scss' as *;

.serial-code-table {
  .el-input__inner {
    height: $spacing-unit * 4;
  }
}

.flex-row {
  display: flex;
  flex-direction: row;
  gap: $spacing-unit;
  align-items: center;
}

.text-sub-color {
  font-size: $font-small-size;
}
</style>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import moment from 'moment'
import { mapActions, mapState } from 'pinia'
import twitterText from 'twitter-text'
import { defineComponent } from 'vue'

import ApplicantName from '@/client/components/_atoms/applicant_name'
import Icon from '@/client/components/_atoms/basic_icon'
import CsvDownload from '@/client/components/_atoms/csv_download'
import Pagination from '@/client/components/_atoms/pagination'
import SelectForm from '@/client/components/_atoms/select_form'
import api from '@/client/core/api'
import Util from '@/client/core/util'
import SerialCodeImportReset from '@/client/features/twitter_applicant/serial_code_import_reset'
import { TrackingService } from '@/client/services'
import { useSystemStore } from '@/client/store/useSystemStore'
import { useTwitterApplicantStore } from '@/client/store/useTwitterApplicantStore'
import { useTwitterSerialCodeDialogStore } from '@/client/store/useTwitterSerialCodeDialogStore'

export default defineComponent({
  props: {
    onChangeSortBy: Function,
    onChange: Function,
    onClickSerialCodeCreate: Function,
    isChangeWithoutSubmit: Boolean
  },
  components: {
    Icon,
    CsvDownload,
    SelectForm,
    Pagination,
    ApplicantName,
    SerialCodeImportReset
  },
  data() {
    return {
      screen: '',
      // ステータス
      status: {
        value: '',
        placeholder: 'ステータス',
        options: [
          {
            label: '指定なし',
            value: ''
          },
          {
            label: '割り当て済',
            value: 'assign'
          },
          {
            label: '未割り当て',
            value: 'unassigned'
          }
        ],
        onChange: (value: number) => {
          TrackingService.sendEvent('select:当選メッセージの管理|シルアルコード管理|割当指定')

          this.status.value = value
          if (this.options.filter === value) {
            return
          }

          // オプションを切り替えるときは 1 ページに戻る
          this.setSerialCodeListParams({ filter: value, pagingNo: 1 })
        }
      },
      assignTiming: {
        value: '',
        options: [
          { label: '指定なし', value: '' },
          { label: '当選DM', value: 'DM' },
          { label: 'WEBページ', value: 'web' }
        ],
        onChange: (value: 'DM' | 'web') => {
          // オプションを切り替えるときは 1 ページに戻る
          this.setSerialCodeListParams({ type: value, pagingNo: 1 })
        }
      },
      action: {
        options: [
          {
            label: '使用済みコードインポート',
            value: 'usedCodeImport'
          },
          {
            label: '使用済みコード解除',
            value: 'usedCodeReset'
          },
          {
            label: '未割り当てコード削除',
            value: 'serialCodeReset'
          }
        ]
      }
    }
  },
  computed: {
    ...mapState(useTwitterSerialCodeDialogStore, {
      campaignId: state => state.campaignId,
      prizeId: state => state.prizeId,
      serialCodeList: state => state.serialCode.list,
      options: state => ({
        filter: state.serialCode.params.filter,
        sortBy: state.serialCode.params.sortBy,
        pagingNo: state.serialCode.params.pagingNo,
        limitCount: state.serialCode.params.limitCount,
        total: state.serialCode.total,
        countAssign: state.serialCode.countAssign,
        countUnassign: state.serialCode.countUnassign,
        type: state.serialCode.params.type
      })
    }),
    ...mapState(useSystemStore, {
      contractStatus: state => state.currentGroup.contractStatus
    }),
    ...mapState(useTwitterApplicantStore, {
      campaign: state => state.campaign ?? {},
      campaignPrize: state => state.campaignPrize ?? {}
    }),
    is_table_screen() {
      return this.screen === ''
    }
  },
  watch: {
    options: function () {
      this.status.options[0].label = '指定なし'
      this.status.options[1].label = '割り当て済'
      this.status.options[2].label = '未割り当て'
    }
  },
  methods: {
    ...mapActions(useTwitterSerialCodeDialogStore, ['setSerialCodeListParams']),
    createNewSerialCode() {
      TrackingService.sendEvent('click:当選メッセージの管理|シルアルコード管理|追加')

      this.onClickSerialCodeCreate()
    },

    /**
     * ページを変更イベント
     * @param {number} pagingNo ページング
     */
    onChangePagingNo(pagingNo: number) {
      this.setSerialCodeListParams({
        pagingNo
      })
    },

    /**
     * ページを変更イベント
     * @param {number} limitCount リミット数
     */
    onChangeLimitCount(limitCount: number) {
      this.setSerialCodeListParams({
        limitCount,
        pagingNo: 1
      })
    },

    /**
     * 選択した一括操作を実行
     * @param {string} command コマンド
     */
    async selectAction(command: string) {
      if (command) TrackingService.sendEvent('select:当選メッセージの管理|シルアルコード管理|一括操作')

      switch (command) {
        case 'usedCodeImport':
          this.screen = 'import'
          break
        case 'usedCodeReset':
          this.screen = 'used_code_reset'
          break
        case 'serialCodeReset':
          this.screen = 'code_reset'
          break
        default:
          this.screen = ''
      }
    },

    /**
     * シリアルコードを削除
     * @param {number} serialCode メッセージキューID
     */
    async deleteSerialCode(serialCode: number) {
      TrackingService.sendEvent('click:当選メッセージの管理|シルアルコード管理|削除')

      const confirm = window.confirm('シリアルコードを削除してよろしいですか?')
      if (!confirm) {
        return
      }
      const result = await api.delete(`/twitter_serial_codes/${serialCode}`)
      if (result.error && result.error.type === 'NOT_EXISTS') {
        this.$notify({
          title: '対象のシリアルコードはすでに削除されています。',
          customClass: 'danger',
          duration: 5000
        })
        if (typeof this.onChange === 'function') {
          this.onChange()
        }
        return
      }

      // エラーがある場合はエラーメッセージを表示
      if (!result.data) {
        this.$notify({
          title: 'シリアルコードの削除に失敗しました。',
          message: '恐れ入りますが、時間をおいて再度お試しください。',
          customClass: 'danger',
          duration: 5000
        })
        return
      }

      // 成功メッセージを表示
      this.$notify({
        title: 'シリアルコードを削除しました。',
        customClass: 'success',
        duration: 5000
      })

      if (typeof this.onChange === 'function') {
        this.onChange()
      }
    },

    async downloadCsv() {
      TrackingService.sendEvent('click:当選メッセージの管理|シルアルコード管理|CSVダウンロード')

      const campaignId = this.campaignId
      const prizeId = this.prizeId
      const params = Object.assign({ campaignId, prizeId }, this.options)
      params.limitCount = -1
      const result = await api.get('/twitter_serial_codes', {
        params
      })
      if (!result.data) {
        return {
          error: 'ERROR_LOADING'
        }
      }

      const serialCodeList = result.data.serialCode
      const filename = `campaign_serial_codes_${moment().format('YYYY_MM_DD')}`
      const csvData = []
      csvData.push([
        'No',
        'ステータス',
        '割り当てタイミング',
        '使用済み',
        'シリアルコード',
        'アカウント名',
        'アカウントスクリーン名',
        'アカウント画像',
        'フォロー中',
        '警告アカウント'
      ])

      serialCodeList.forEach((serialCode, index) => {
        csvData.push([
          index + 1,
          serialCode.twCampaignApplicantId ? '割り当て済' : '未割り当て',
          serialCode.type === 0 ? 'DM' : 'WEBページ',
          serialCode.userIsUsed,
          serialCode.serialCode,
          serialCode.applicant.name,
          serialCode.applicant.screenName,
          serialCode.applicant.pictureUrl,
          serialCode.applicant.name ? (serialCode.applicant.isFollowing ? 1 : 0) : null,
          serialCode.applicant.name ? (serialCode.applicant.isWarning ? 1 : 0) : null
        ])
      })

      return {
        filename,
        data: csvData
      }
    },

    /**
     * シリアルコードにURLが含まれる場合、アンカーリンクにする
     * @param {string} serialCode
     * @returns {string}
     */
    convertSerialCode(serialCode: string): string {
      const escapeSerialCode = this.htmlEscape(serialCode)
      const entities = twitterText.extractEntitiesWithIndices(escapeSerialCode, {
        extractUrlsWithoutProtocol: true
      })

      return twitterText.autoLinkEntities(escapeSerialCode, entities, {
        targetBlank: true
      })
    },
    /**
     * HTMLで使用する特殊文字を除去する
     */
    htmlEscape(text: string): string {
      const entities = {
        '>': '&gt;',
        '<': '&lt;',
        '"': '&quot;',
        "'": '&#39;'
      }

      return text.replace(/["'><]/g, character => entities[character])
    },
    /**
     * ヘッダーをクリックするとソートする
     * @param {*} column
     */
    headerClick(column: any) {
      switch (column.label) {
        case 'ステータス':
          TrackingService.sendEvent('sort:当選メッセージの管理|シルアルコード管理|ステータス')
          break
        case 'シリアルコード':
          TrackingService.sendEvent('sort:当選メッセージの管理|シルアルコード管理|シルアルコード')
          break
        case '割り当てアカウント':
          TrackingService.sendEvent('sort:当選メッセージの管理|シルアルコード管理|割当アカウント')
          break
        default:
          break
      }

      if (column.sortBy.indexOf('-') === 0) {
        if (this.options.sortBy === column.sortBy) {
          this.onChangeSortBy(column.sortBy.substring(1))
        } else {
          this.onChangeSortBy(column.sortBy)
        }
      } else {
        if (this.options.sortBy === column.sortBy) {
          this.onChangeSortBy('-' + column.sortBy)
        } else {
          this.onChangeSortBy(column.sortBy)
        }
      }
    },
    /**
     * ヘッダー描画
     * @param {*} createElement
     * @param {*} { column }
     */
    renderHeader(createElement: any, { column }: any) {
      return Util.renderHeader(createElement, column.label, Util.getSortClass(this.options.sortBy, column.sortBy))
    },
    reset() {
      this.screen = ''
    }
  }
})
</script>
